import React from "react"
import styled from "styled-components/macro"
import colors from "../../../scripts/colors"
import Icon from "../../../images/iconmonstr-arrow-24---outline---lt.svg"
import { decode } from "js-base64"

type PropTypes = {
  imgArr: any[]
  vidUrl: string
  facilityName: string
}

const HomeGalleryStyles = styled.div`
  display: none;
  flex-direction: column;
  @media screen and (min-width: 1024px) {
    width: 100%;
    display: flex;
  }
  @media screen and (min-width: 1500px) {
    width: 365px;
  }
`

const GalleryItem = styled.div`
  display: flex;
  align-items: stretch;
  margin-bottom: 17px;
  &:last-child {
    margin-bottom: 0;
  }
`

const GalleryImgWrap = styled.div`
  width: 100%;
  height: 285px;
  border: 0.5px solid ${colors("blue", "xdk")};
  img {
    width: 100%;
    height: 285px;
    object-fit: cover;
    object-position: center;
  }
`

const GalleryItemDecoration = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  margin-left: 8px;
`

const GalleryItemLine = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  width: 3px;
  background-color: ${colors("grey", "xlt")};
`

const GalleryItemIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* transform: rotate(90deg); */
  width: 35px;
  color: ${colors("purple")};
`

const HomeIntroGallery: React.FC<PropTypes> = ({
  imgArr,
  vidUrl,
  facilityName,
}) => {
  const imgList = imgArr.map((imgObj, index) => {
    const publicId = JSON.parse(decode(imgObj.image.asset.source.id)).public_id

    const imgUrl = `https://res.cloudinary.com/agoraservices/g_auto,q_auto,f_auto/${publicId}`

    return (
      <GalleryItem key={publicId}>
        <GalleryImgWrap>
          <img
            loading="lazy"
            src={imgUrl}
            alt={imgObj.altText ? imgObj.altText : facilityName}
          />
        </GalleryImgWrap>
        <GalleryItemDecoration>
          <GalleryItemLine />
          <GalleryItemIcon id={`GalleryIcon--${index + 1}`} />
        </GalleryItemDecoration>
      </GalleryItem>
    )
  })

  !vidUrl && imgArr.length >= 3 && imgList.pop()

  return <HomeGalleryStyles>{imgList}</HomeGalleryStyles>
}

export default HomeIntroGallery
